import { render, staticRenderFns } from "./IconReset.vue?vue&type=template&id=423fffa2&"
import script from "./IconReset.vue?vue&type=script&lang=js&"
export * from "./IconReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports